<template>
    <div>
        <div class="row text-center my-4">
            <div class="col-sm-6 font-weight-bold text-left">Nosaukums</div>
            <div class="col-sm-6 font-weight-bold text-right">Darbības</div>
        </div>
        <div class="col-sm-12" style="max-height: 552px; overflow-x: hidden;">
        <UsersGroupsListItem v-for="userGroup in currentCompany.usersGroups" :user-group="userGroup" :key="userGroup._id"/>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    import UsersGroupsListItem from '@/components/users-groups/UsersGroupsListItem';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';

    export default {
        name: 'users-groups-list',
        components: {UsersGroupsListItem},
        computed: mapGetters('company', {
            /** @type {Company|*} */
            currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
        }),
    }
</script>